<div class="background-container">
    <div class="micro-home-container">
        <!-- Logo fuera del panel para coincidir con login -->
        <div *ngIf="!showEmailPanel" class="header-section animate__animated animate__fadeInDown">
            <img
                src="assets/img/logo-signomedico-2.png"
                alt="Signo Médico"
                class="brand-logo"
            />
            <p class="slogan-auth">Bienvenido a Signo Médico</p>
        </div>
        <!-- Overlay para descarga de la app -->
        <div
            *ngIf="showOverlay"
            class="overlay-modal"
            [ngClass]="{ 'fade-in': showOverlay, 'fade-out': !showOverlay }"
        >
            <div class="modal-content">
                <button class="close-btn" (click)="closeOverlay()">
                    <i class="fas fa-times"></i>
                </button>
                <p>
                    Descargue nuestra aplicación móvil para acceder a sus servicios
                    de manera rápida y sencilla.
                </p>
                <div class="modal-actions">
                    <button class="btn-primary" (click)="redirectToApp()">
                        Descargar App
                    </button>
                </div>
            </div>
        </div>

        <!-- Panel de email para afiliación -->
        <div *ngIf="showEmailPanel" class="email-panel">
            
            <!-- Spinner y mensaje (para estados 14 y sin solicitud) -->
            <div *ngIf="showSpinner" class="spinner-container">
                <div class="spinner"></div>
                <p class="spinner-message">{{ spinnerMessage }}</p>
            </div>

            <!-- Mensaje de estado estático (para estados 15 y 16) -->
            <div *ngIf="showStatusMessage" class="status-message-container">
                <div class="status-icon">
                    <i class="fas fa-info-circle"></i>
                </div>
                <p class="status-message">{{ statusMessage }}</p>
                <button class="btn-primary" (click)="volverAlLogin()">Volver al inicio</button>
            </div>

            <!-- Contenido normal del panel (se oculta cuando showSpinner o showStatusMessage es true) -->
            <div *ngIf="!showSpinner && !showStatusMessage">
                <div class="welcome-section">
                    <p class="welcome-text">Ingrese su email para comenzar</p>
                </div>

                <div class="action-section">
                    <div class="input-group">
                        <input 
                            type="email" 
                            [(ngModel)]="email"
                            placeholder="Ingrese su email"
                            class="email-input"
                            (keyup.enter)="verificarEmail()"
                        >
                    </div>

                    <button class="login-btn" (click)="verificarEmail()">
                        <i class="fas fa-user-plus btn-icon"></i>
                        Afiliarse
                    </button>

                    <div class="back-link" (click)="volverAlLogin()">
                        <i class="fas fa-arrow-left"></i>
                        Volver al inicio
                    </div>
                </div>
            </div>
        </div>

        <!-- Contenido principal minimalista -->
        <div *ngIf="!showEmailPanel" class="login-panel animate__animated animate__fadeIn">
            <div class="welcome-section">
                <h1 class="welcome-title">Bienvenido</h1>
                <p class="welcome-text">
                    Regístrese o inicie sesión en nuestro portal
                </p>
            </div>

            <div class="action-section">
                <button
                    class="login-btn"
                    (click)="navigateRoot('/profile-authentication')"
                >
                    <i class="fas fa-user-circle btn-icon"></i>
                    Ingresar al portal
                </button>
                
                <div hidden class="register-link" (click)="verificarInscripcion()">
                    ¿No esta afiliado? <strong>Afíliese aquí</strong>
                </div>

                <div class="app-link" (click)="openOverlay()">
                    ¿Necesita la aplicación móvil?
                </div>

                <div class="polpriv-link" (click)="openBlank('PPSM')">
                    Políticas de privacidad
                </div>

            </div>
        </div>
    </div>
</div>